import { API_URL, setHeader } from 'api';
import axios from 'axios';
import pickBy from 'lodash/pickBy';
import omit from 'lodash/omit';

const URL = `${API_URL}/users`;

export const fetchUserByEmail = params => {
  const req = setHeader(axios);
  return req.get(`${URL}`, { params });
};

export const fetchUsers = p => {
  const req = setHeader(axios);
  const params = {
    start: p.start,
    limit: p.limit,
    searchQuery: p.query,
  };
  return req.get(`${URL}`, { params });
};

export const fetchChildUsers = p => {
  const req = setHeader(axios);
  const params = {
    start: p.start,
    limit: p.limit,
    status: p.status,
    searchQuery: p.query,
    thirdParty: p.thirdParty,
  };
  return req.get(`${URL}`, { params });
};

export const fetchUsersByRoleID = p => {
  const req = setHeader(axios);
  const params = {
    start: p.start,
    limit: p.limit,
    roleID: p.roleID,
  };
  return req.get(`${URL}`, { params });
};

export const createUser = user => {
  const req = setHeader(axios);
  user = {
    ...user,
    roleName: user.role.roleName,
    // thirdPartyID: user.thirdParty !== null ? user.thirdParty.vendorID : undefined,
	thirdPartyIDs: user.thirdParties ? user.thirdParties.map(tp => parseInt(tp.vendorID)) : null,
    departmentID: user.department && user.department.departmentID,
  };
  user = omit(user, ['role', 'thirdParties', 'thirdParty', 'department', 'status']);
  return req.post(`${URL}`, pickBy(user)); //pickBy will clear null values before sending
};

export const resendEmail = (userID, emailType) => {
	const req = setHeader(axios);
	return req.put(`${URL}/${userID}/resendemail/${emailType}`);
}

export const createContact = newVendor => {
  const req = setHeader(axios);
  newVendor = { roleName: 'THIRD_PARTY', ...newVendor };
  return req.post(`${URL}`, newVendor);
};

export const updateUser = (id, user) => {
  const req = setHeader(axios);
  user = {
    ...user,
    userStatus: user.status && user.status.userStatusID,
    passwordReset: user.passwordReset ? true : false,
    departmentID: user.department && user.department.departmentID,
    roleName: user.role && user.role.roleName,
	thirdPartyIDs: user.thirdParties ? user.thirdParties.map(tp => tp.vendorID) : null
  };
  user = omit(user, ['role', 'thirdParties', 'department', 'status']);

  return req.put(`${URL}/${id}`, pickBy(user)); //pickBy will clear null values before sending
};

export const resetPassword = email => {
  return axios.post(`${URL}/reset`, { email });
};

export const changePassword = (userID, oldPassword, newPassword) => {
  const req = setHeader(axios);
  return req.put(`${URL}/reset`, {
    userID,
    oldPassword,
    newPassword,
  });
};

export const login = (email, password) => {
  return axios.post(`${API_URL}/auth/login`, { email, password });
};

export const fetchAppUser = token => {
  // if called with token, just refresh token
  if (token) {
    return refreshToken(token);
  }

  // if called without token, try to get from local storage to refresh
  token = '';
  if (sessionStorage.getItem('token')) {
    token = sessionStorage.getItem('token');
  }
  // call with or without the token set (without will auto fail but still trigger the middleware)
  return refreshToken(token);
};

export const shibLogin = () => {
  return (window.location.href = `${API_URL}/auth/sso-login`);
};

export const shibLogout = () => {
  return (window.location.href = `${API_URL}/auth/sso-logout`);
};

export const refreshToken = token => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  return axios.get(`${API_URL}/auth/refresh-token`);
};
